import React from 'react';
import SuperintendenciaLogo from '../../assets/SuperintendenciaLogo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Sección de Contacto */}
        <div className="footer-contact">
          <h3>Contactanos</h3>
          <div className="contact-info">
            <p className="contact-item">
              Email: <a href="mailto:dictamenes@ivisnk9.co" className="contact-link">dictamenes@ivisnk9.co</a>
            </p>
            {/* <p className="contact-item">
              Phone: <span className="contact-text">+57 317 823 2323</span>
            </p> */}
          </div>
        </div>

        {/* Sección de Copyright */}
        <div className="footer-copyright">
          <p className="copyright-text">
            IVIS NK9 2025. Todos los derechos reservados
          </p>
        </div>

        {/* Sección Regulatoria */}
        <div className="footer-regulatory">
          <div className="superintendencia-container">
            <img 
              src={SuperintendenciaLogo} 
              alt="Superintendencia Financiera de Colombia" 
              className="superintendencia-logo"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 